/* SapTour variant selector: keep the selected variant id and displayed prices in sync. */
(function () {
  function money(cents) {
    var n = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'HKD' }).format(n); }
    catch (e) { return 'HK$' + n.toFixed(2); }
  }
  function init(root) {
    var main = root.querySelector('[data-name="main-product-section"]');
    if (!main) return;
    var variants;
    try { variants = JSON.parse(main.textContent || '[]'); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    var form = root.querySelector('form.main-product-form');
    var idInput = form && form.querySelector('input.product-variant-id[name="id"]');
    var selectors = Array.prototype.slice.call(root.querySelectorAll('select.select-option-box, input.product-swatch-option'));
    function selected() {
      var values = [];
      root.querySelectorAll('select.select-option-box').forEach(function (s) { values.push(s.value); });
      root.querySelectorAll('input.product-swatch-option:checked').forEach(function (x) { values.push(x.value); });
      return values;
    }
    function find() {
      var vals = selected();
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }).every(function (x, i) { return x === vals[i]; });
      }) || variants[0];
    }
    function update() {
      var v = find();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-variant-sku]').forEach(function (x) { x.textContent = ''; });
      root.querySelectorAll('[data-main-price] .price, [data-main-price] .price-item, [data-main-price] .product-price-main').forEach(function (x) {
        if (v.price != null) x.textContent = money(v.price);
      });
      root.querySelectorAll('[data-main-price]').forEach(function (x) { x.setAttribute('data-selected-variant-id', v.id); });
      root.dispatchEvent(new CustomEvent('saptour:variant:change', { bubbles: true, detail: { variant: v } }));
    }
    selectors.forEach(function (x) { x.addEventListener('change', update); x.addEventListener('click', function () { setTimeout(update, 0); }); });
    update();
  }
  function boot() { document.querySelectorAll('main-product[data-product-info]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
